<template>
  <div class="menu-list">
    <el-menu
      :default-active="active"
      mode="vertical"
      class="el-menu-vertical-demo"
      :unique-opened="uniqueOpened"
      @select="handleSelect"
    >
      <menu-item :routes="routes"></menu-item>
      <!-- <template v-for="(route, index) in routes">
        <el-menu-item
          v-if="$utils.isEmpty(route.children)"
          :key="index"
          :index="route.path"
          class="single-item"
        >
          <span class="menu-text">
            <span :class="['iconfont', route.meta.icon, 'menu-icon']"></span>
            <el-badge is-dot class="item" :hidden="!route.alert">{{ route.title }}</el-badge>
          </span>
        </el-menu-item>
        <el-submenu v-else :key="index" :index="route.title">
          <template slot="title">
            <span class="menu-text">
              <span :class="['iconfont', route.meta.icon, 'menu-icon']"></span>
              {{ route.title }}
            </span>
          </template>
          <template v-for="(sub, subIndex) in route.children">
            <el-menu-item v-if="$utils.isEmpty(sub.children)" :key="sub.path + subIndex" :index="sub.path">
              <span class="left-line"></span>
              <el-badge is-dot class="item" :hidden="!sub.alert">{{ sub.title }}</el-badge>
            </el-menu-item>
            <el-submenu v-else :key="sub.path + subIndex" :index="sub.path">
              <template slot="title">
                <span class="sub-menu-margin-left">
                  {{ sub.title }}
                </span>
              </template>
              <el-menu-item
                v-for="(sub1, subIndex1) in sub.children"
                :key="sub1.path + subIndex1"
                :index="sub1.path"
              >
                <span class="menu-text">
                  <el-badge is-dot class="item" :hidden="!sub1.meta.alert">{{ sub1.meta.title }}</el-badge>
                </span>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template> -->
    </el-menu>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import MenuItem from './MenuItem.vue'
export default {
  name: 'Menu',
  components: {
    MenuItem
  },
  data() {
    return {
      active: '',
      uniqueOpened: true
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    ...mapState({
      menus: state => state.app.menus,
      allFuncs: state => state.app.allFuncs,
      userInfo: state => state.app.userInfo,
      newContentAlert: state => state.app.newContentAlert
    }),
    routes() {
      const { menus, allFuncs, newContentAlert } = this
      const hasAuth = item => {
        if (item.meta.auth && item.meta.auth.code) {
          //不在权限管理集合中的授权，默认通过
          return !allFuncs[item.meta.auth.code] || !!menus[item.meta.auth.code]
        } else {
          return true
        }
      }
      let routes = this.$router.options.routes.filter(route => {
        const children = this.$utils.isEmpty(route.children) ? [] : route.children
        const hasLevel1 = children.some(
          item => item.meta && item.meta.breadLevel === 0 && hasAuth(item)
        )
        return hasLevel1
      })

      return routes.map(option => {
        const children = option.children.filter(
          item => item.meta && item.meta.breadLevel === 0 && hasAuth(item)
        )
        if (children.length > 1) {
          return {
            ...option,
            title: option.meta.title,
            children: children.map(item => {
              return {
                ...item,
                title: item.meta.title,
                alert: newContentAlert[item.name]
              }
            })
          }
        } else {
          return {
            ...children[0],
            title: children[0] ? children[0].meta.title : '',
            alert: children[0] ? newContentAlert[children[0].name] : undefined
          }
        }
      })
    }
  },
  watch: {
    $route: {
      handler(val, old) {
        this.routes.map(ele => {
          if (ele.path === val.path) this.active = val.path
        })
      },
      deep: true
    }
  },
  created() {
    this.active = this.$route.path
  },
  methods: {
    handleSelect(val) {
      this.$router.push(val)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'menu-list',
  (
    --menu-item-text-color: #fff,
    --menu-item-active-text-color: #45c2ff,
    --menu-item-subitem-active-text-color: #45c2ff,
    --menu-item-active-start-color: rgba(109, 212, 255, 0.35),
    --menu-item-active-end-color: rgba(109, 212, 254, 0),
    --menu-item-active-border-color: #6dd4ff,
    --menu-item-hover: rgba(109, 212, 255, 0.35),
    --menu-item-background-color: #0b1b3d7f,
    --menu-item-submenu-text-color: #fff
  ),
  (
    --menu-item-text-color: #122836,
    --menu-item-active-text-color: #fff,
    --menu-item-subitem-active-text-color: #45c2ff,
    --menu-item-active-start-color: #45c2ff,
    --menu-item-active-end-color: #45c2ff,
    --menu-item-active-border-color: #6dd4ff,
    --menu-item-hover: #cccccc,
    --menu-item-background-color: #f0f2f67f,
    --menu-item-submenu-text-color: #fff
  )
);

.menu-list {
  @include adaptation(
    (
      --menu-title-height: 95px,
      --menu-item-height: 40px,
      --menu-item-font-size: 12px,
      --menu-item-icon-size: 16px,
      --menu-item-margin-left: 12px,
      --menu-item-icon-margin-right: 12px,
      --menu-item-active-border: 2px,
      --menu-item-subitem-margin-left: 28px,
      --menu-item-submenu-arrow-right: 24px,
      --menu-item-submenu-arrow-margin-top: -6px
    )
  );
  height: calc(100vh - var(--menu-title-height));
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  /deep/ {
    .el-menu {
      width: var(--base-menu-width);
      border-right: solid 0 transparent;
      background-color: transparent;

      .el-menu-item {
        display: flex;
        align-items: center;
        border-bottom: none;
        height: var(--menu-item-height);
        line-height: var(--menu-item-height);
        color: var(--menu-item-text-color);
        font-size: var(--menu-item-font-size);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-right: var(--menu-item-active-border) solid transparent;

        .menu-text {
          user-select: none;
          display: flex;
          align-items: center;
          margin-left: var(--menu-item-margin-left);

          .menu-icon {
            margin-right: var(--menu-item-icon-margin-right);
          }

          .iconfont {
            font-size: var(--menu-item-icon-size);
          }
        }
      }

      .el-menu-item:hover {
        background-color: var(--menu-item-hover);
      }

      .el-menu-item.is-active {
        color: var(--menu-item-active-text-color);
        background: linear-gradient(
          260deg,
          var(--menu-item-active-start-color) 0%,
          var(--menu-item-active-end-color) 100%
        );
        border-right: var(--menu-item-active-border) solid var(--menu-item-active-border-color);
      }

      .el-submenu {
        .el-submenu__title {
          height: var(--menu-item-height);
          line-height: var(--menu-item-height);
          color: var(--menu-item-text-color);
          font-size: var(--menu-item-font-size);
          border-right: var(--menu-item-active-border) solid transparent;
          display: flex;
          align-items: center;

          .menu-text {
            user-select: none;
            display: flex;
            align-items: center;
            margin-left: var(--menu-item-margin-left);

            .menu-icon {
              margin-right: var(--menu-item-icon-margin-right);
            }

            .iconfont {
              font-size: var(--menu-item-icon-size);
            }
          }

          .el-submenu__icon-arrow {
            -webkit-transform: rotateZ(-90deg);
            transform: rotateZ(-90deg);
            font-size: var(--menu-item-font-size);
            right: var(--menu-item-submenu-arrow-right);
            margin-top: var(--menu-item-submenu-arrow-margin-top);
            color: var(--menu-item-text-color);
          }
        }

        .el-submenu__title:hover {
          background-color: var(--menu-item-hover);
        }

        .el-menu-item {
          border-bottom: none;
          background: var(--menu-item-background-color);
          border-right: var(--menu-item-active-border) solid transparent;

          .left-line {
            display: inline-block;
            width: var(--menu-item-subitem-margin-left);
            height: var(--menu-item-height);
          }
        }

        .el-menu-item:hover {
          background-color: var(--menu-item-hover);
        }

        .el-menu-item.is-active {
          background: linear-gradient(
            260deg,
            var(--menu-item-active-start-color) 0%,
            var(--menu-item-active-end-color) 100%
          );
          border-right: var(--menu-item-active-border) solid var(--menu-item-active-border-color);
          color: var(--menu-item-submenu-text-color);
        }
      }
      // .el-submenu.is-active {
      //   .el-submenu__title {
      //     background: linear-gradient(
      //       260deg,
      //       var(--menu-item-active-start-color) 0%,
      //       var(--menu-item-active-end-color) 100%
      //     );
      //     border-right: var(--menu-item-active-border) solid var(--menu-item-active-border-color);
      //     color: var(--menu-item-submenu-text-color);

      //     .el-submenu__icon-arrow {
      //       -webkit-transform: rotateZ(-90deg);
      //       transform: rotateZ(-90deg);
      //       color: var(--menu-item-submenu-text-color);
      //     }
      //   }
      // }
      .el-submenu.is-opened {
        .el-submenu__title {
          .el-submenu__icon-arrow {
            -webkit-transform: rotateZ(0deg);
            transform: rotateZ(0deg);
          }
        }
      }
    }
  }
}
</style>
